import { ClientLogo, ModuleTitle } from "@components/ui-kit";
import type { Client } from "@src/__generated__/urql-graphql";
import { observer } from "mobx-react-lite";
import type { DeepPick } from "ts-essentials";

interface ClientTitleProps {
  client: {
    name: Client["name"];
    image?: DeepPick<
      Client["image"],
      {
        urls: {
          thumbnail: never;
        };
      }
    >;
  };
}

const ClientTitle = ({ client }: ClientTitleProps) => {
  return (
    <div className="flex items-center my-1">
      <div className="mr-6">
        <ClientLogo src={client.image?.urls.thumbnail} />
      </div>
      <ModuleTitle text={client.name} />
    </div>
  );
};

export default observer(ClientTitle);
